export function date(args?) {
    args = args || {};

    if ($.type(args) == "date" || $.type(args) == "string") {
        args = {
            date: args
        };
    }

    var d = new Date(args.date);

    if (d.getFullYear() < 1970) {
        d.setFullYear(d.getFullYear() + 100);
    }

    if (args.backwardOffset || args.forwardOffset) {
        var offset = -d.getTimezoneOffset();
        if (args.forwardOffset) {
            offset = d.getTimezoneOffset();
        }
        d = d.addMinutes(offset);
    }

    return d;
}
